import { render, staticRenderFns } from "./tab-bookprice-list.vue?vue&type=template&id=6572fb12&scoped=true&"
import script from "./tab-bookprice-list.vue?vue&type=script&lang=js&"
export * from "./tab-bookprice-list.vue?vue&type=script&lang=js&"
import style0 from "./tab-bookprice-list.vue?vue&type=style&index=0&id=6572fb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6572fb12",
  null
  
)

export default component.exports